// Version : 0.0.1
// Author : Vignesh

import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** GET TRAIL BALANCE START *********************** */
export const TrailBalanceGetBranch = (addData: any) => {
	const data = {
		ProfitAndLossToken: addData,
	};
	console.log({ FIN_API_URL });
	const url = `${FIN_API_URL}getParticularAccountTrialBalanceReport`;
	return makeApiCall(url, data);
};
/** ***************** GET TRAIL BALANCE END *********************** */
